import React, { useState, useEffect, VFC, useMemo } from "react"
import { useKeenSlider } from "keen-slider/react"
import GuideFrame from "./GuideFrame"
import "keen-slider/keen-slider.min.css"
import styles from '../../styles/front/gallery/TopImages.module.sass'

type Props = {
  topImages: any[],
  zoomIcon: string,
  guideFrameData: any
}

const TopImages: VFC<Props> = (props) => {
  const {
    topImages,
    zoomIcon,
    guideFrameData,
  } = props

  const isPC = () => {
    return (
      document.querySelector('.menu-list') &&
      document.defaultView.getComputedStyle(document.querySelector('.menu-list'), null).display !== 'none'
    )
  }

  const RESIZE_1600 = '1600'
  const RESIZE_686 = '686'
  const RESIZE_240 = '240'

  const [currentSlide, setCurrentSlide] = useState(0)
  const [slideLoaded, setSlideLoaded] = useState(false)

  const pcImageCount = topImages.length

  const [moveIndex, setMoveIndex] = useState(7)

  const thumbnailCount = pcImageCount >= 7 ? 7 : pcImageCount
  const DURATION = 3500
  const SLIDER_CHANGE_TIME = 2000
  const GUIDE_FRAME_SLIDER_CHANGE_TIME = 6000
  const SPACING = 5
  const [sliderRef, instanceSliderRef] = useKeenSlider<HTMLDivElement>(
    {
      loop: true,
      defaultAnimation: {
        duration: DURATION,
      },
      slides: {
        origin: "center",
        perView: "auto",
        spacing: SPACING,
      },
      created() {
        setSlideLoaded(true)
      },
    },
    [
      (slider) => {
        let timeout: ReturnType<typeof setTimeout>
        let mouseOver = false
        function clearNextTimeout() {
          clearTimeout(timeout)
        }
        function nextTimeout() {
          clearTimeout(timeout)
          if (mouseOver) return
          timeout = setTimeout(() => {
            if (slider.slides.length > 0) {
              slider.next()
            }
          }, SLIDER_CHANGE_TIME)
        }
        slider.on("created", () => {
          slider.container.addEventListener("mouseover", () => {
            mouseOver = true
            clearNextTimeout()
          })
          slider.container.addEventListener("mouseout", () => {
            mouseOver = false
            nextTimeout()
          })
          nextTimeout()
        })
        slider.on("dragStarted", clearNextTimeout)
        slider.on("animationEnded", nextTimeout)
        slider.on("updated", nextTimeout)
        slider.on("slideChanged", () => {
          // 現在のスライドインデックスを取得
          const currentSlideIndex = slider.track.details.rel
          setCurrentSlide(currentSlideIndex)

          // 誘導枠の設定がない場合は処理しない
          if(guideFrameData == null) return

          // 全スライド数を取得
          const totalSlides = slider.track.details.slides.length

          // 最後のスライドの場合(誘導枠)
          if (currentSlideIndex === totalSlides - 1) {
            mouseOver = true
            clearNextTimeout()
            setTimeout(() => {
              mouseOver = false
              nextTimeout()
            }, GUIDE_FRAME_SLIDER_CHANGE_TIME)
          }
        })
      },
    ]
  )

  const [currentThumbnailSlide, setCurrentThumbnailSlide] = useState(0)
  const [thumbnailRef, instanceThumbnailRef] = useKeenSlider<HTMLDivElement>(
    {
      loop: true,
      initial: 0,
      slides: {
        perView: thumbnailCount,
        spacing: 8,
      },
      slideChanged(slider) {
        setCurrentThumbnailSlide(slider.track.details.rel)
      },
    },
  )

  const [currentPopSlide, setCurrentPopSlide] = useState(0)

  const [popupRef, instancePopupRef] = useKeenSlider<HTMLDivElement>(
    {
      loop: true,
      initial: 0,
      slides: {
        perView: 1,
      },
      slideChanged(slider) {
        setCurrentPopSlide(slider.track.details.rel)
      },
    },
  )

  const [spPopupRef, instanceSpPopupRef] = useKeenSlider<HTMLDivElement>(
    {
      loop: true,
      initial: 0,
      slides: {
        perView: 1,
      },
      slideChanged(slider) {
        // 現在のスライドインデックスを取得
        const currentSlideIndex = slider.track.details.rel
        setCurrentPopSlide(currentSlideIndex)

        // 誘導枠の設定がない場合は処理しない
        if(guideFrameData == null) return

        // 全スライド数を取得
        const totalSlides = slider.track.details.slides.length

        const icon_close = document.getElementById('icon_close')
        const dots = document.querySelectorAll<HTMLElement>('.dots')

        // 最後のスライドの場合(誘導枠)
        if (currentSlideIndex === totalSlides - 1) {
          icon_close.style.opacity = '0.1'
          dots.forEach((element) => {
            element.style.opacity = '0.1'
          })
        }else{
          icon_close.style.opacity = 'unset'
          dots.forEach((element) => {
            element.style.opacity = 'unset'
          })
        }
      },
    },
  )

  const [currentSpSlide, setCurrentSpSlide] = useState(0)
  const [slideSpLoaded, setSlideSpLoaded] = useState(false)

  const [sliderSpRef, instanceSliderSpRef] = useKeenSlider<HTMLDivElement>(
    {
      loop: true,
      defaultAnimation: {
        duration: DURATION,
      },
      slides: {
        origin: "center",
        perView: "auto",
        spacing: SPACING,
      },
      created() {
        setSlideSpLoaded(true)
      },
    },
    [
      (slider) => {
        let timeout: ReturnType<typeof setTimeout>
        let mouseOver = false
        function clearNextTimeout() {
          clearTimeout(timeout)
        }
        function nextTimeout() {
          clearTimeout(timeout)
          if (mouseOver) return
          timeout = setTimeout(() => {
            if (slider.slides.length > 0) {
              slider.next()
            }
          }, SLIDER_CHANGE_TIME)
        }
        slider.on("created", () => {
          slider.container.addEventListener("mouseover", () => {
            mouseOver = true
            clearNextTimeout()
          })
          slider.container.addEventListener("mouseout", () => {
            mouseOver = false
            nextTimeout()
          })
          nextTimeout()
        })
        slider.on("dragStarted", clearNextTimeout)
        slider.on("animationEnded", nextTimeout)
        slider.on("updated", nextTimeout)
        slider.on("slideChanged", () => {
          // 現在のスライドインデックスを取得
          const currentSlideIndex = slider.track.details.rel
          setCurrentSpSlide(currentSlideIndex)

          // 誘導枠の設定がない場合は処理しない
          if(guideFrameData == null) return

          // 全スライド数を取得
          const totalSlides = slider.track.details.slides.length

          const icon_zoom = document.getElementById('icon_zoom')
          const icon_close = document.getElementById('icon_close')
          const dots = document.querySelectorAll<HTMLElement>('.dots')

          // 最後のスライドの場合(誘導枠)
          if (currentSlideIndex === totalSlides - 1) {
            icon_zoom.style.opacity = '0.1'
            icon_close.style.opacity = '0.1'
            dots.forEach((element) => {
              element.style.opacity = '0.1'
            })
            mouseOver = true
            clearNextTimeout()
            setTimeout(() => {
              mouseOver = false
              nextTimeout()
            }, GUIDE_FRAME_SLIDER_CHANGE_TIME)
          }else{
            icon_zoom.style.opacity = 'unset'
            icon_close.style.opacity = 'unset'
            dots.forEach((element) => {
              element.style.opacity = 'unset'
            })
          }
        })
      },
    ]
  )

  function openPopup(id, index){
    if(id == "pc_popup"){
      instancePopupRef.current?.moveToIdx(index)
    }else{
      instanceSpPopupRef.current?.moveToIdx(index)
    }
    let targetPopup = document.getElementById(id)
    document.body.setAttribute("style","overflow: hidden;")
    targetPopup.removeAttribute("style")
  }

  function closePopup(id){
    let targetPopup = document.getElementById(id)
    document.body.setAttribute("style","overflow: visible;")
    targetPopup.setAttribute("style","visibility:hidden;")
  }

  const closeWithClickOutSideMethod = (e, id) => {
    if (e.target === e.currentTarget) {
      //メニューの外側をクリックしたときだけメニューを閉じる
      let targetPopup = document.getElementById(id)
      document.body.setAttribute("style","overflow: visible;")
      targetPopup.setAttribute("style","visibility:hidden;")
    }
  }

  const handleOnError = (e: any, image: string) => {
    if (e.target.src !== image) {
      e.target.onerror = null
      e.target.src = image
    }
  }

  function updateMoveIndex(e, action){
    e.stopPropagation()
    if(action == "prev"){
      instanceThumbnailRef.current?.prev()
      setMoveIndex(moveIndex - 1)
    }else{
      instanceThumbnailRef.current?.next()
      setMoveIndex(moveIndex + 1)
    }
  }

  function setWidth(image){
    let width
    if(image.width > image.height){
      width = 790
    }else{
      width = 356
    }
    return width
  }

  const spHeight = (window.innerWidth / 5) * 3
  function setWidthSp(image){
    let style
    if(image.width > image.height){
      style = {
        minWidth: `100vw`,
        aspectRatio: `5/3`
      }
    }else{
      style = {
        minWidth: window.innerWidth / 2 - SPACING,
        height: spHeight
      }
    }

    return style
  }

  function getImageUrl(url, size){
    let resize_url
    if(url.includes('gallery_detail')){
      resize_url = url.replace('/store/gallery_detail/', `/store/gallery_detail/resize_${size}x/`).replace(/.(png|jpg|jpeg)$/, '.webp')
    }else{
      resize_url = url.replace('/store/gallery_top/', `/store/gallery_top/resize_${size}x/`).replace(/.(png|jpg|jpeg)$/, '.webp')
    }
    return resize_url
  }

  const memoizedStyles = useMemo(() => {
    const images = guideFrameData
      ? [...topImages, guideFrameData.guideFrame]
      : topImages

    return images
      .filter(image => image != null)
      .map(image => setWidthSp(image))
  }, [topImages, guideFrameData])

  useEffect(() => {
    const setSliderHeight = () => {
      const slider = document.querySelector('.keen-slider.sp') as HTMLElement;
      if (slider) {
        slider.style.setProperty('height', `${spHeight}px`, 'important');
      }
    }
    setSliderHeight()

    if (currentSlide == moveIndex) {
      instanceThumbnailRef.current?.moveToIdx(moveIndex)
      let nextMoveIndex = moveIndex + 7
      if(nextMoveIndex > pcImageCount - 1){
        nextMoveIndex = nextMoveIndex - pcImageCount
      }
      setMoveIndex(nextMoveIndex)
    }
  }, [currentSlide]);

  return (
    <div>
      {isPC() && pcImageCount > 0 &&
        <div className={styles.pcImagesContainer}>
          <div ref={pcImageCount > (guideFrameData ? 0 : 1) ? sliderRef : undefined} className="keen-slider" style={{ maxWidth: 1000, margin: "auto", height: 474 }}>
            {topImages.filter(image => image != null).map((pcImage, index) => (
              <div style={{ minWidth: setWidth(pcImage) }} className={"keen-slider__slide" + (pcImageCount == 1 ? " one_image" : "")} key={index} onClick={() => openPopup("pc_popup", index)}>
                <img
                  alt={pcImage.alt_text}
                  key={index}
                  src={getImageUrl(pcImage.image_url, RESIZE_1600)}
                  loading="lazy"
                  onError={(e) => handleOnError(e, pcImage.image_url)}
                />
              </div>
            ))}
            {guideFrameData &&  (
              <div style={{ minWidth: 1000}} className={"keen-slider__slide guide-frame"} key={pcImageCount} onClick={() => openPopup("pc_popup", pcImageCount)}>
                <img
                  alt={guideFrameData.guideFrame.alt_text}
                  key={pcImageCount}
                  src={getImageUrl(guideFrameData.guideFrame.image_url, RESIZE_1600)}
                  loading="lazy"
                  onError={(e) => handleOnError(e, guideFrameData.guideFrame.image_url)}
                />
                <GuideFrame
                  inquiry_data1 = {guideFrameData.inquiry_data1}
                  inquiry_data2 = {guideFrameData.inquiry_data2}
                  menu_name = {guideFrameData.menu_name}
                />
              </div>
              )}
          </div>

          {thumbnailCount == 7 &&
            <div className={styles.thumbnailBox} style={{ position: 'relative', width: 790 }}>
              <div ref={thumbnailRef} className={"keen-slider thumbnail" + " " + styles.thumbnail}>
                {topImages.filter(image => image != null).map((pcImage, index) => (
                  <div className={"keen-slider__slide thumbnail" + (currentSlide == index ? "" : " gray")} key={index} onClick={() => {instanceSliderRef.current?.moveToIdx(index)}}>
                    <img
                      alt={pcImage.alt_text}
                      key={index}
                      src={getImageUrl(pcImage.image_url, RESIZE_240)}
                      loading="lazy"
                      onError={(e) => handleOnError(e, pcImage.image_url)}
                    />
                  </div>
                ))}
              </div>
              {slideLoaded && instanceThumbnailRef.current && (
                <>
                  <div className="dli-chevron-round -left" onClick={(e) => updateMoveIndex(e, "prev")}/>
                  <div className="dli-chevron-round -right" onClick={(e) => updateMoveIndex(e, "next")}/>
                </>
              )}
            </div>
          }
          {thumbnailCount != 7 && thumbnailCount != 1 &&
            <div className={"keen-slider thumbnail" + " " + styles.thumbnail + " " + styles.few}>
              {topImages.filter(image => image != null).map((pcImage, index) => (
                <div className={"keen-slider__slide thumbnail" + " " + styles.thumbnailslide + (currentSlide == index ? "" : " gray")} key={index} onClick={() => {instanceSliderRef.current?.moveToIdx(index)}}>
                  <img
                    alt={pcImage.alt_text}
                    key={index}
                    src={getImageUrl(pcImage.image_url, RESIZE_240)}
                    loading="lazy"
                    onError={(e) => handleOnError(e, pcImage.image_url)}
                  />
                </div>
              ))}
            </div>
          }
          <div style={{ visibility: 'hidden' }} className={styles.background} id="pc_popup" onClick={(e) => { closeWithClickOutSideMethod(e, "pc_popup")}}>
            <div ref={pcImageCount > (guideFrameData ? 0 : 1) ? popupRef : undefined} className={"keen-slider" + " " + styles.popup}>
              {topImages.filter(image => image != null).map((pcImage, index) => (
                <div className={"keen-slider__slide pc_popup"} key={index}>
                  <img
                    alt={pcImage.alt_text}
                    key={index}
                    src={getImageUrl(pcImage.image_url, RESIZE_1600)}
                    loading="lazy"
                    onError={(e) => handleOnError(e, pcImage.image_url)}
                  />
                </div>
              ))}
              {guideFrameData && (
                  <div className={"keen-slider__slide pc_popup guide-frame"} key={pcImageCount}>
                    <img
                      alt={guideFrameData.guideFrame.alt_text}
                      key={pcImageCount}
                      src={getImageUrl(guideFrameData.guideFrame.image_url, RESIZE_1600)}
                      loading="lazy"
                      onError={(e) => handleOnError(e, guideFrameData.guideFrame.image_url)}
                    />
                    <GuideFrame
                      inquiry_data1 = {guideFrameData.inquiry_data1}
                      inquiry_data2 = {guideFrameData.inquiry_data2}
                      menu_name = {guideFrameData.menu_name}
                    />
                  </div>
                )}
            </div>
          </div>
        </div>
      }
      {!isPC() && topImages.length > 0 &&
        <div className={styles.spImagesContainer}>
          <div ref={topImages.length > (guideFrameData ? 0 : 1) ? sliderSpRef : undefined} className="keen-slider sp">
            {topImages.filter(image => image != null).map((spImage, index) => (
              <div style={memoizedStyles[index]} className={"keen-slider__slide sp"} key={index}>
                <img
                  alt={spImage.alt_text}
                  key={index}
                  src={getImageUrl(spImage.image_url, RESIZE_686)}
                  {...(index === 0 ? {} : { loading: "lazy" })}
                  onError={(e) => handleOnError(e, spImage.image_url)}
                />
              </div>
            ))}
            {guideFrameData && (
                <div style={memoizedStyles[topImages.length]} className={"keen-slider__slide sp guide-frame"} key={topImages.length}>
                  <img
                    alt={guideFrameData.guideFrame.alt_text}
                    key={topImages.length}
                    src={getImageUrl(guideFrameData.guideFrame.image_url, RESIZE_686)}
                    loading="lazy"
                    onError={(e) => handleOnError(e, guideFrameData.guideFrame.image_url)}
                  />
                  <GuideFrame
                    inquiry_data1 = {guideFrameData.inquiry_data1}
                    inquiry_data2 = {guideFrameData.inquiry_data2}
                    menu_name = {guideFrameData.menu_name}
                  />
                </div>
            )}
            <div id="icon_zoom" className="icon_zoom" onClick={() => openPopup("sp_popup", currentSpSlide)}>
              <img src={zoomIcon} width="40" height="40"/>
            </div>
          </div>
          {slideSpLoaded && instanceSliderSpRef.current && (
            <div className="dots">
              {[
                ...Array(instanceSliderSpRef.current.track.details.slides.length).keys(),
              ].map((idx) => {
                return (
                  <button
                    key={idx}
                    onClick={() => {
                      instanceSliderSpRef.current?.moveToIdx(idx)
                    }}
                    className={"dot" + (currentSpSlide === idx ? " active" : "")}
                  ></button>
                )
              })}
            </div>
          )}
          <div style={{ visibility: 'hidden' }} id="sp_popup" className={styles.background}>
            <div ref={topImages.length > (guideFrameData ? 0 : 1) ? spPopupRef : undefined} className={"keen-slider" + " " + styles.spPopup}>
              {topImages.filter(image => image != null).map((spImage, index) => (

                <div className={"keen-slider__slide sp popup" + (topImages.length == 1 ? " one_image" : "")} key={index}>
                  <img
                    alt={spImage.alt_text}
                    key={index}
                    src={getImageUrl(spImage.image_url, RESIZE_686)}
                    loading="lazy"
                    onError={(e) => handleOnError(e, spImage.image_url)}
                  />
                </div>

              ))}
              {guideFrameData && (
                  <div className={"keen-slider__slide sp popup guide-frame popup"} key={topImages.length}>
                    <img
                      alt={guideFrameData.guideFrame.alt_text}
                      key={topImages.length}
                      src={getImageUrl(guideFrameData.guideFrame.image_url, RESIZE_686)}
                      loading="lazy"
                      onError={(e) => handleOnError(e, guideFrameData.guideFrame.image_url)}
                    />
                    <GuideFrame
                      inquiry_data1 = {guideFrameData.inquiry_data1}
                      inquiry_data2 = {guideFrameData.inquiry_data2}
                      menu_name = {guideFrameData.menu_name}
                    />
                  </div>
                )}
            </div>
            <div id="icon_close" className="icon_close" onClick={() => closePopup("sp_popup")}/>
            {slideSpLoaded && instanceSpPopupRef.current && (
              <div className="dots pop">
                {[
                  ...Array(instanceSpPopupRef.current.track.details.slides.length).keys(),
                ].map((idx) => {
                  return (
                    <button
                      key={idx}
                      onClick={() => {
                        instanceSpPopupRef.current?.moveToIdx(idx)
                      }}
                      className={"dot" + (currentPopSlide === idx ? " active" : "")}
                    ></button>
                  )
                })}
              </div>
            )}
          </div>
        </div>
      }
    </div>
  )
}

export default TopImages
